import React, { Component } from 'react'
import { Button, Panel } from 'react-bootstrap'
import CalendarHeatmap from 'react-calendar-heatmap';


const colorSelect = (val) => {
	if (val < 10) {
		return 0;
	}
	if (val >= 10 && val < 40) {
		return 1;
	}
	if (val >= 40 && val < 120) {
		return 2;
	}
	if (val >= 120 && val < 240) {
		return 4;
	}
	return 5;
}

class Dashboard extends Component {
  render() {
	const startDate = new Date();
	startDate.setDate(startDate.getDate() - 365);
    return (
      <div className="container">
        {this.props.countWords < 5 ? (
          <div className="alert alert-success" role="alert">
            У вас пока нет слов в словаре или их меньше 5. Для начала вам нужно выбрать любой английский текст, который хотите прочитать. Это может быть все что угодно: статья, книга, субтитры и т.д... Скопируйте небольшой фрагмент текста, нажмите кнопку добавить слова, и вставьте в текстовое поле скопированный текст.
          </div>
        ) : null}
        <Panel>
		  <Panel.Heading className="text-right">
              <Button title={this.props.countWords < 5 ? "В словре должно быть не менее 5 слов" : null} disabled={this.props.countWords < 5 ? true : false} onClick={() => this.props.getUserWords(this.props.userWords)} bsStyle="primary">Учить слова</Button>&nbsp;
              <Button onClick={this.props.toggleSourceTextModal} bsStyle="primary">Добавить слова</Button>
          </Panel.Heading>
          <Panel.Body>
            <div className="col-12 col-md-3 text-center">
              <div className="h3 lead">Слов в словаре</div>
              <div className="h2 text-muted hexlet-font-weight-lighter">
                <a role="button" onClick={this.props.toggleUserWordsManageModal}>
                  {this.props.countWords}
                </a>
              </div>
            </div>
            <div className="col-12 col-md-3 text-center">
              <div className="h3 lead">Уровень изучения</div>
              <div className="h2 text-muted hexlet-font-weight-lighter">{this.props.scoreLevel}%</div>
            </div>
            <div className="col-12 col-md-3 text-center">
              <div className="h3 lead">Полнотью изучено слов</div>
              <div className="h2 text-muted hexlet-font-weight-lighter">{this.props.countStudiedWords}</div>
            </div>
            <div className="col-12 col-md-3 text-center">
              <div className="h3 lead">Новых слов</div>
              <div className="h2 text-muted hexlet-font-weight-lighter">{this.props.countNewWords}</div>
            </div>
			<div className="col-12 col-md-12 text-center" style={{ padding: '30px 3px 3px 3px' }}>
				<CalendarHeatmap
				  startDate={startDate}
				  endDate={(new Date())}
				  titleForValue={v => v ? `Count: ${v.countPractice}` : 'Count: 0'}
				  values={this.props.activity.map(e => {
					  return {date: e.date, count: colorSelect(e.countPractice), countPractice: e.countPractice};
				  })}
				  classForValue={(value) => {
					if (!value || value.count === 0) {
					  return 'color-empty';
					}
					return `color-scale-${value.count}`;
				  }}
				/>
			</div>
          </Panel.Body>
          <Panel.Footer className="text-right">
              <Button title={this.props.countWords < 5 ? "В словре должно быть не менее 5 слов" : null} disabled={this.props.countWords < 5 ? true : false} onClick={() => this.props.getUserWords(this.props.userWords)} bsStyle="primary">Учить слова</Button>&nbsp;
              <Button onClick={this.props.toggleSourceTextModal} bsStyle="primary">Добавить слова</Button>
          </Panel.Footer>
        </Panel>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js